export default __webpack_public_path__ + "static/media/vendor_sharing.50670124.png";